<template>
  <main>
    <div class="container-fluid">
      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="car-recognition-tab" data-bs-toggle="pill" data-bs-target="#stay-average"
            type="button" role="tab" aria-controls="car-recognition" aria-selected="true"> 遊客平均停留時間 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="estimate-people-tab" data-bs-toggle="pill" data-bs-target="#stay-average-by-date" 
            type="button" role="tab" aria-controls="estimate-people" aria-selected="false">遊客平均停留時間（天）</button>
        </li>
      </ul>
      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <stay-average></stay-average>
        <stay-average-by-date></stay-average-by-date>
      </div>
    </div>
  </main>
</template>

<script>
import stayAverage from './stayAverage.vue';
import stayAverageByDate from './stayAverageByDate.vue';




export default {
  components: { stayAverage,stayAverageByDate},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
